import { cn } from '@/lib/utils';

export const TierCardBorder = ({ isFeatured }: { isFeatured: boolean }) => {
  return (
    <div
      aria-hidden="true"
      className={cn(
        'pointer-events-none absolute inset-y-0 right-0 hidden w-1/2 rounded-lg sm:block ring-1 ring-halfmast-900/10',
        {
          'ring-2 ring-primary': isFeatured,
        },
      )}
    />
  );
};
